import { render } from "./SearchBoard.vue?vue&type=template&id=7377e16d&scoped=true"
import script from "./SearchBoard.vue?vue&type=script&lang=js"
export * from "./SearchBoard.vue?vue&type=script&lang=js"

import "./SearchBoard.vue?vue&type=style&index=0&id=7377e16d&lang=sass"
import "./SearchBoard.vue?vue&type=style&index=1&id=7377e16d&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7377e16d"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn,QIcon,QField});
